import { BACKEND_URL } from '@/core/config';
import { server } from '../core/server/axios';

interface CreateCashTransferVariables {
    from: {
        amount: number;
        cashId: string | number;
        initiator: string;
        kassaId: string | number;
        rate: number;
        value: number;
    };
    to: {
        amount: number;
        cashId: string | number;
        departmentId: number;
        initiator: string;
        kassaId: string | number;
        rate: number;
        value: number;
    }[];
    initiator: string;
}

export class CashManagementController {
    async createCashTransfer(request: CreateCashTransferVariables) {
        return await server.post('/Application/cashManagement', request, {
            baseURL: BACKEND_URL
        });
    }

    async updateCashTransferRequest(request: { requestId: string | number, status: 1 | 7 }) {
        return await server.post(`/Application/updateCashManagement?requestId=${request.requestId}&status=${request.status}`, request, {
            baseURL: BACKEND_URL
        });
    }

    async getHistoryCashTransfer() {
        return await server.get(`/Application/cashManagementlist/1/80`, {
            baseURL: BACKEND_URL
        });
    }

    async pushTelegram(request: {
        initiator: string,
        income: string | number,
        depName: string,
        deviation: string | number,
        currency: string
    }) {
        return await server.post(`/TelegramBot/cashManagement`, request, {
            baseURL: BACKEND_URL
        });
    }

    async pushTelegramIncidents({ text }: { text: string }) {
        return await server.post(`/TelegramBot/support?msg=${text}`, {}, {
            baseURL: BACKEND_URL
        });
    }
}